<template>
  <div class="templateTable">
    <listheader :titleName="titleHeaderName" :flag='flag' />
    <div v-show="!show" class="cCommonTable">
      <van-row
        class="tableItem"
        v-for="(item1, index) in tableData"
        :key="index"
      >
        <van-swipe-cell>
          <a class="itemDetailBox">
            <van-row v-for="(item2, index) in tableHead" :key="index" v-show="item2.clearable">
              <van-col class="itemDetail">
                <span class="itemTitle" style='float:left;'>{{ item2.label }}:</span>
                <div class='imgBox' style='display:inline-block;float:left;margin-left:10px;' v-if="item2.prop=='id'">
                  <cUpload
                        ref="cUpload"
                        :preview="true"
                        :isDel='false'
                        @uploadFiles="uploadFiles"
                        uploadType="inspectionRecord"
                        :uploadParentId="item1[item2.prop]"
                        acceptFileType="jpg,jpeg,png,gif"
                        :limitNum="5" limitSize="10M"/>
                </div>
                <!-- <img v-else-if="item2.prop=='checkPeopleSignature'" style='width:100%;height:auto;'
                :src="baseUrl+'/mongodb/getDownloadOutputStream?fileId='+item1[item2.prop]" alt='暂无图片'> -->
				<img v-else-if="item2.prop=='checkPeopleSignature'" style='width:100%;height:auto;'
				:src="item1[item2.prop]" alt='暂无图片'>
                <span v-else>{{item1[item2.prop]}}</span>
              </van-col>
            </van-row>
          </a>
          <template #right>
            <van-button
              square
              text="删除"
              type="danger"
              class="delete-button"
              @click="delDetail(item1.id)"
            />
          </template>
        </van-swipe-cell>
        <div style='margin-top:10px;margin-left:50%;color:#bbb;'>
			  <van-icon v-show='!showAll' name="arrow-down" @click="showAllClick" />
			  <van-icon v-show='showAll' name="arrow-up" @click="showSomeClick" />
         </div>
         <div class="assessbtn">
              <van-button type="info" plain v-if="item1.checkFlag != '合规'"  @click="assessClick(item1)">督办单</van-button>
              <van-button type="info" plain v-if="addinstate && item1.checkDept == qyname" @click="editData(item1)">编辑</van-button>
              <van-button type="info" plain v-if="delinstate" @click="delDetail(item1.id)">删除</van-button>
              <van-button type="info" plain v-if="addinstate && item1.checkFlag != '合规'" @click="recall(item1.id)">撤销</van-button>
         </div>
      </van-row>
        <div id="wrap">
        <div id="home" v-if="addinstate">
          <img
            :src="require('../../assets/images/add.png')"
            ref="addIcon"
            class="addIcon"
            @click="clickAddIcon"
          />
        </div>
      </div>
    </div>
    <div v-if="show" class="templateForm">
      <div class="topBar" style="top: 0;margin-top: 0;z-index: 999;">
          <van-row>
            <van-col :span="2">
              <a class="el-icon-arrow-left topBarImg" @click="show=false" />
            </van-col>
            <van-col :span="20" style="text-align: center; ">
              <p>监督检查</p>
            </van-col>
            <van-col :span="2">

            </van-col>
          </van-row>
        </div>
        <div class="formbox">
           <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
              <el-form-item style="width:100%;" >
              <van-row>

                <van-col span="6"  style="text-align:right;margin-top:8px;">
                         专业化公司:
                   </van-col>
                   <van-col span="1"></van-col>
                   <van-col span="17"  style="margin-top:8px;">
                      <van-field
                       v-model="ruleForm.companyName"
                       :disabled="true"
                       type="text"
                       placeholder="请输入检查单位"
                       :rules="[{ required: true, message: '请输入检查单位' }]"
                     />
                  </van-col>

             </van-row>
             </el-form-item>
              <el-form-item style="width:100%;" >
              <van-row>

                <van-col span="6"  style="text-align:right;margin-top:8px;">
                         基层工厂:
                   </van-col>
                  <van-col span="1" >
                  </van-col>
                   <van-col span="17" style="margin-top:8px;">
                      <van-field
                       v-model="ruleForm.qyName"
                       disabled
                       type="text"
                       placeholder="请输入检查单位"
                       :rules="[{ required: true, message: '请输入检查单位' }]"
                     />
                  </van-col>

             </van-row>
              </el-form-item >
               <el-form-item style="width:100%;" >
             <van-row>

                <van-col span="6"  style="text-align:right;margin-top:8px;">
                         检查单位:
                   </van-col>
                  <van-col span="1" >
                  </van-col>
                   <van-col span="17" style="margin-top:8px;">
                      <van-field
                       v-model="ruleForm.checkDept"
                       disabled
                       type="text"
                       placeholder="请输入检查单位"
                       :rules="[{ required: true, message: '请输入检查单位' }]"
                     />
                  </van-col>

             </van-row>
              </el-form-item>
               <el-form-item style="width:100%;" >
             <van-row>

                <van-col span="6" style="text-align:right;">
                         作业类别:
                </van-col >
                 <van-col span="1" >
                  </van-col>
                <van-col span="17">
                   <el-select
                   v-model="ruleForm.workClassify"
                   style="width:85%;" placeholder="请选择作业类别"
                   :disabled="true">
                   <el-option
                     v-for="item in workClassifyList"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
                   </el-option>
                   </el-select>
                </van-col>

             </van-row>
              </el-form-item>
               <el-form-item style="width:100%;" >
             <van-row>

                <van-col span="6" style="text-align:right;">
                         作业级别:
                </van-col >
                 <van-col span="1" >
                  </van-col>
                <van-col span="17">
                   <el-select
                   v-model="ruleForm.workLevel"
                    style="width:85%"
                     placeholder="请选择作业级别"
                     :disabled="true">
                   <el-option
                     v-for="item in workLevelList"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
                   </el-option>
                   </el-select>
                </van-col>

             </van-row>
              </el-form-item>
               <el-form-item style="width:100%;" >
              <van-row>

                <van-col span="6" style="text-align:right;">
                         相关方作业:
                </van-col >
                 <van-col span="1" >
                  </van-col>
                <van-col span="17">
                   <el-select
                   v-model="ruleForm.isRelation"
                    style="width:85%" placeholder="请选择作业种类"
                    :disabled="true">
                   <el-option
                     v-for="item in isRelationlList"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
                   </el-option>
                   </el-select>
                </van-col>

             </van-row>
              </el-form-item>
               <el-form-item style="width:100%;" >
              <van-row>

                <van-col span="6"  style="text-align:right;margin-top:8px;">
                        作业编码:
                   </van-col>
                  <van-col span="1" >
                  </van-col>
                   <van-col span="17" style="margin-top:8px;">
                        <van-field
                          v-model="ruleForm.workCode"
                          type="text"
                          disabled
                          placeholder="请输入作业编码"
                        />
                  </van-col>

             </van-row>
              </el-form-item>
               <el-form-item style="width:100%;" >
             <van-row >

                <van-col span="6"  style="text-align:right;margin-top:8px;">
                         检查人:
                   </van-col>
                  <van-col span="1" >
                  </van-col>
                   <van-col span="17" style="margin-top:8px;">
                     <van-field
                       style="text-align:right;"
                       v-model="ruleForm.checkPeople"
                       type="text"
                       :disabled="true"
                       placeholder="请输入检查人"
                       :rules="[{ required: true, message: '请输入检查人' }]"
                      />
                  </van-col>

             </van-row>
              </el-form-item>
               <el-form-item style="width:100%;" >
              <van-row>

                <van-col span="6"  style="text-align:right;margin-top:8px;">
                        联系方式:
                   </van-col>
                  <van-col span="1" >
                  </van-col>
                   <van-col span="17" style="margin-top:8px;">
                        <van-field
                        :disabled="true"
                          v-model="ruleForm.checkPhone"
                          type="text"
                          placeholder="请输入联系方式"
                          :rules="[{ required: true, message: '请输入联系方式' }]"
                        />
                  </van-col>

             </van-row>
              </el-form-item>
              <el-form-item prop="checkTime">
              <van-row>

                   <van-col span="6" style="text-align:right;">
                         检查时间:
                   </van-col>
                  <van-col span="1" >
                  </van-col>
                   <van-col span="17">
                           <!-- <cDataPicker  @changeValue="changeValue" v-model="ruleForm.checkTime"
					                 type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择时间"
					                 /> -->
                               <vDataPicker
                               @changeValue="changeValue"
                               :item="item"
                               style="width:85%"
                               :defaultValue="ruleForm.checkTime"
                               />
                   </van-col>

              </van-row>
            </el-form-item>
             <el-form-item style="width:100%;" prop="checkFlag">
              <van-row>

                <van-col span="6" style="text-align:right;">
                       合格类别:
                </van-col >
                 <van-col span="1" >
                  </van-col>
                <van-col span="17">
                   <el-select style="width:85%"  v-model="ruleForm.checkFlag" placeholder="请选择合格类别:" :disabled="disabledState">
                   <el-option
                     v-for="item in checkFlagList"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
                   </el-option>
                   </el-select>
                </van-col>

              </van-row>
               </el-form-item>
              <el-form-item style="width:100%;" v-if="ruleForm.checkFlag!='合规'">
             <van-row>

                <van-col span="6" style="text-align:right;">
                         问题类别:
                </van-col >
                 <van-col span="1" >
                  </van-col>
                <van-col span="17">
                   <el-select  v-model="ruleForm.issueType" style="width:85%;" placeholder="请选择问题类别" :disabled="disabledState">
                   <el-option
                     v-for="item in issueTypeList"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
                   </el-option>
                   </el-select>
                </van-col>

             </van-row>
              </el-form-item>
              <el-form-item style="width:100%;" prop="checkIssue">
              <van-row>

                <van-col span="6" style="text-align:right;margin-top:8px;">
                    检查描述:
                </van-col>
                  <van-col span="1"  >
                  </van-col>
                 <van-col span="17" >
                    <el-input
                   style="width:85%;"
                   v-model="ruleForm.checkIssue"
                   type="textarea"
                   :disabled="disabledState "
                   :rows="4"></el-input>
                </van-col>

              </van-row>
               </el-form-item>
              <el-form-item style="width:100%;" >
              <van-row>
<!--                :class="(ruleForm.checkFlag!='合规' || ruleForm.checkFlag=='') ? 'labelSpe' : ''"-->
                <van-col span="7"  style="text-align:right;">
                    图片上传：
                </van-col>
                 <!-- <van-col span="1">
                </van-col> -->
                 <van-col span="17">
                      <cUpload  ref="cUpload" v-if="!disabledState" :preview="true" @uploadFiles="uploadFiles"
                      uploadType="inspectionRecord" :uploadParentId="ruleForm.id" acceptFileType="jpg,jpeg,png,gif"
                      :limitNum="5" limitSize="10M"/>
                      <cPhotoWall v-else :photoList="photoList"/>
                </van-col>

              </van-row>
               </el-form-item>
                <el-form-item style="width:100%;" prop="checkPeopleSignature">
               <van-row>

                <van-col span="7" style="text-align:right;" class='labelSpe'>
                    检查人签字：
                </van-col>
                 <!-- <van-col span="1" >
                  </van-col> -->
                 <van-col span="17">
                  <!-- <van-button type="info" @click="writeClick"
                    >点击签字</van-button> -->
                  <!-- <img v-if="ruleForm.checkPeopleSignature" style='width:100%;height:auto;'
                    :src="baseUrl+'/mongodb/getDownloadOutputStream?fileId='+ruleForm.checkPeopleSignature" alt='暂无图片'> -->
					<img v-if="ruleForm.checkPeopleSignature" style='width:100%;height:auto;'
					  :src="ruleForm.checkPeopleSignature" alt='暂无图片'>
                  <el-button type="primary" @click="writeClick">点击签字</el-button>
                </van-col>
                  <!-- <van-popup
                  v-model="show1"
                  position="bottom"
                  closeable
                  :style="{ height: '41%' }"
                >
                <van-cell >
                  <cSignCanvas
                       class="canvascell"
                       :id="ruleForm.checkPeopleSignature"
                       @clearwrite="clearwrite"
                       @addSignFile="addSignFile"
                       ref="cSignCanvas"
                    />
                </van-cell>
               </van-popup> -->
              </van-row>
               </el-form-item>
           <el-form-item style="width:100%;" >
              <div class="topBar">
                <van-row>
                  <van-col @click="submitForm('ruleForm')" :span="24" style="text-align: center">
                    <p>保存</p>
                  </van-col>
                </van-row>
              </div>
           </el-form-item>
          </el-form>
        </div>
      </div>
    <el-dialog title="检查人签字"
     center
     width="100%"
     top="100%"
     custom-class="inspectionRecordBody1"
     :append-to-body="true"
      :visible.sync="show1"
      v-if='show1'>
        <cSignCanvas
                       class="canvascell"
                       :previewId="ruleForm.checkPeopleSignature"
                       @clearwrite="clearwrite"
                       @addSignBase64="addSignBase64"
                       ref="cSignCanvas"
                    />
    </el-dialog>
    <!-- <el-dialog title="中粮集团质量安全重大事项督办令"
     center
     width="100%"
     top=""
     custom-class="inspectionRecordBody1"
     :append-to-body="true"
    :visible.sync="rateState"> -->
        <!-- <el-rate
          v-model="rateValue"
          @change="change"
          show-score>
        </el-rate> -->
        <!-- <cOrder :rowItem="rowItem" ref="cOrder" @orderOpen="orderOpen"/>
    </el-dialog> -->
    <div v-if='rateState' class='inspectionRecord1'>
      <div class="topBar" style="top: 0;margin-top: 0;z-index: 999;">
          <van-row>
            <van-col :span="2">
              <a class="el-icon-arrow-left topBarImg" @click="rateState=false" />
            </van-col>
            <van-col :span="20" style="text-align: center; ">
              <p>质量安全事项督办令</p>
            </van-col>
            <van-col :span="2">

            </van-col>
          </van-row>
        </div>
      <cOrder v-if='rateState' :rowItem="rowItem" :addinstate="addinstate" ref="cOrder" @orderOpen="orderOpen"/>
    </div>
  </div>
</template>

<script>
import listheader from "../header/backHeader";
import axios from 'axios'
import cSignCanvas from "../element/c-signCanvas";
import cDataPicker from "../element/c-data-picker"
import cUpload from '../element/c-upload'
import cPhotoWall from '../element/c-photoWall'
import vDataPicker from "../vant/v-data-picker"
import cOrder from './order.vue'
export default {
  name: "inspectionRecord",

  props: {

  },

  data() {
    return {
      baseUrl: sessionStorage.getItem("baseURL"),
      rowItem:"",
      rateState:false,
      rateValue:null,
      showAll:false,
       getTable:{
          // limit: 10,
          // page: 1,
          workid:"",//当前行的id
        },
      loading: false,
      finished: false,
      show: false,
      show1: false,
      itemid: "",
      showPicker: false,
       //问题类别下拉选择框
         issueTypeList:[
            {
            value: '五必须',
            label: '五必须'
           }, {
             value: '信息的真实性',
             label: '信息的真实性'
           }, {
             value: '违章作业',
             label: '违章作业'
           }, {
             value: '劳动组织',
             label: '劳动组织'
           }, {
             value: '风险管控',
             label: '风险管控'
           },
           {
            value: '提级管理',
            label: '提级管理'
           }, {
             value: '变更管理',
             label: '变更管理'
           }, {
             value: '视频抽查',
             label: '视频抽查'
           },{
             value: '其他',
             label: '其他'
           },{
             value: '建议',
             label: '建议'
           },
        ],
      header: {},
      listData: [{}],
      switchChecked:true,
      disabledState:false,
        checkFlagList:[
          // {
          //   value: '重大不合规',
          //   label: '重大不合规'
          //  },
           {
             value: '不合规',
             label: '不合规'
           },
           {
             value: '合规',
             label: '合规'
           },
        ],
       isRelationlList:[
          {
            value: '无',
            label: '无'
           },
           {
             value: '甲类',
             label: '甲类'
           },
           {
            value: '乙类',
            label: '乙类'
           },
           {
             value: '丙类',
             label: '丙类'
           },
        ],
         workLevelList:[
            {
            value: '一般危险',
            label: '一般危险'
           },
           {
             value: '较大危险',
             label: '较大危险'
           },
           {
             value: '高度危险',
             label: '高度危险'
           },
         ],
        workClassifyList:[
           {
            value: '动火作业',
            label: '动火作业'
           },
           {
             value: '有限空间作业',
             label: '有限空间作业'
           },
           {
             value: '高处作业',
             label: '高处作业'
           },
           {
             value: '临时用电作业',
             label: '临时用电作业'
           },
        ],
      tableHead:[
          {
          	prop: 'checkDept',
            label: '检查单位',
            minWidth: '175',
            align: "center",
            type: 'input',
            clearable: true,
          },
          {
          	prop: 'checkFlag',
            label: '合格类别',
            minWidth: '100',
            align: "center",
            type: 'input',
            clearable:true,
          },
           {
          	prop: 'issueType',
            label: '问题类别',
            minWidth: '175',
            align: "center",
            type: 'input',
            clearable: true,
          },{
          	prop: 'checkIssue',
            label: '检查描述',
            minWidth: '175',
            align: "center",
            type: 'input',
            clearable: false,
          },
           {
          	prop: 'checkPeople',
            label: '检查人',
            minWidth: '125',
            align: "center",
            type: 'input',
            clearable: false,
          },
          {
          	prop: 'checkPhone',
            label: '联系方式',
            minWidth: '175',
            align: "center",
            type: 'input',
            clearable: false,
          },
          {
          	prop: 'createTime',
            label: '检查时间',
            minWidth: '175',
            align: "center",
            type: 'input',
            clearable: false,
          },
         {
          	prop: 'companyName',
            label: '专业化公司',
            minWidth: '175',
            align: "center",
            type: 'input',
            clearable: false,
          },
          {
          	prop: 'qyName',
            label: '基层工厂',
            minWidth: '175',
            align: "center",
            type: 'input',
            clearable: false,
          },
          {
          	prop: 'workLevel',
            label: '作业级别',
            minWidth: '175',
            align: "center",
            type: 'input',
            clearable: false,
          },
          {
          	prop: 'workClassify',
            label: '作业类别',
            minWidth: '175',
            align: "center",
            type: 'input',
            clearable: false,
          },
          {
          	prop: 'isRelation',
            label: '作业种类',
            minWidth: '175',
            align: "center",
            type: 'input',
            clearable: false,
          },
          {
          	prop: 'workCode',
            label: '作业编码',
            minWidth: '175',
            align: "center",
            type: 'input',
            clearable: false,
          },
          {
          	prop: 'id',
            label: '图片上传',
            minWidth: '175',
            align: "center",
            type: 'input',
            clearable: false,
          },
          {
          	prop: 'checkPeopleSignature',
            label: '检查人签字',
            minWidth: '175',
            align: "center",
            type: 'input',
            clearable: false,
          },
        ],
      tableData: [],
      titleHeaderName: "监督检查",
      flag:'',
      buttonParam: {},
      signId: "",//图片id
      sym2:{},
      sym3:{},
      state1:true,
      sym2arry:[],
      inspection:{
          "id":"",
          "companyName":"",//专业化公司
          "companyId":'',
          "qyName":"",//工厂
          "qyId":'',
          "issueType":"",//问题类别
          "workid":"",//作业id
          "checkImg":"",
          "checkPeople":"",//巡检人
          "checkPhone":"",
          "checkTime":"",//巡检时间
          "passScore":'',//合规评分
          "checkIssue":"",//问题描述
          "checkPeopleSignature":"",//巡检人签字
          "checkDept":"",//检查单位
          "workClassify":"",//作业类别
          "workCode":"",//作业编码
          "workLevel":"",//作业级别
          "isRelation":"",//作业种类
        },
        item:{
          titleName:"检查时间"
        },
      disabledState:false,
      photoList:[],
      rateObj:{},
      itemdataobj:{},//当条数据
       ruleForm:{
          "id":"",
          "companyName":"",//专业化公司
          "companyId":'',
          "qyName":"",//工厂
          "qyId":'',
          "issueType":"",//问题类别
          "workid":"",//作业id
          "checkImg":"",
          "checkPeople":"",//巡检人
          "checkPhone":"",
          "checkTime":"",//巡检时间
          "passScore":'',//合规评分
          "checkIssue":"",//问题描述
          "checkPeopleSignature":"",//巡检人签字
          "checkDept":"",//检查单位
          "workClassify":"",//作业类别
          "workCode":"",//作业编码
          "workLevel":"",//作业级别
          "isRelation":"",//作业种类
          "checkFlag":"",//合规类别
		  "imgbaseurl":""
        },
        ruleFormDemo:{
          "id":"",
          "companyName":"",//专业化公司
          "companyId":'',
          "qyName":"",//工厂
          "qyId":'',
          "issueType":"",//问题类别
          "workid":"",//作业id
          "checkImg":"",
          "checkPeople":"",//巡检人
          "checkPhone":"",
          "checkTime":"",//巡检时间
          "passScore":'',//合规评分
          "checkIssue":"",//问题描述
          "checkPeopleSignature":"",//巡检人签字
          "checkDept":"",//检查单位
          "workClassify":"",//作业类别
          "workCode":"",//作业编码
          "workLevel":"",//作业级别
          "isRelation":"",//作业种类
          "checkFlag":"",//合规类别
		  "imgbaseurl":""
        },
		qyname:'',
		delinstate:false,
		addinstate:false,
        rules: {
          checkTime: [
            { required: true, message: '请选择时间', trigger: 'change' }
          ],
          checkFlag: [
            { required: true, message: '请选择合规类别', trigger: 'change' }
          ],
          checkIssue:[
             { required: true, message: '请填写问题描述', trigger: 'change' }
          ],
          checkPeopleSignature:[
             { required: true, message: '请签字', trigger: 'change' }
          ]
        },
    };
  },

  components: {
    listheader,
    cSignCanvas,
    cDataPicker,
    cPhotoWall,
    cUpload,
    vDataPicker,
    cOrder
  },
  beforeRouteEnter(to,from,next){
    next(vm => {
        vm.flag = from.name
    })
  },
  created() {
	  var userInfo = sessionStorage.getItem("userInfo");
	  if(userInfo){
	  	let a = JSON.parse(userInfo);
		this.qyname = a.qyname
	  }
	  let authStr = sessionStorage.getItem("permission");//角色权限
	  var levelQy = sessionStorage.getItem('levelQy');//工厂等级
	  if(levelQy !='3'){//集团或者专业化公司
	  	this.addinstate=true;
	  }else{
	  	if(authStr){
	  		let userAuth = JSON.parse(authStr);
	  		//if(userAuth['ZYZGBMSPR'] || userAuth['AQGLBMSHR']){//作业主管部门审批人,安全管理部门审核人
	  		if(userAuth['JDJCRY']){//监督检查人员
	  			this.addinstate=true;
	  		}else{
	  			this.addinstate=false;
	  		}
	  	}
	  }
	  if(authStr){
	  	let userAuth = JSON.parse(authStr);
	  	if(userAuth['CJ_ADMIN']){//超级管理员
	  		this.delinstate=true;
	  	}else{
	  		this.delinstate=false;
	  	}
	  }
  },

  mounted() {
    this.itemid = this.$route.params.id ||sessionStorage.getItem('inspectionRecordID')
    this.itemdataobj=this.$route.params.dataobj ||JSON.parse(sessionStorage.getItem('inspectionRecorddataobj'))
	if(sessionStorage.getItem('inspectionRecorddataobj')){
		let it = JSON.parse(sessionStorage.getItem('inspectionRecorddataobj'));
		this.itemdataobj.ZYHGSMZ = it.ZYHGSMZ;
		this.itemdataobj.GCMZ = it.GCMZ;
		this.itemdataobj.DHZY_ZYLB = it.ZYLB;
		this.itemdataobj.DHZY_ZYJB = it.ZYJB;
		this.itemdataobj.DHZY_ZYZBH = it.ZYZBH;
		this.itemdataobj.DHZY_XGFZY = it.XGFZY;
	}
    sessionStorage.setItem('inspectionRecordID',this.itemid)
    //sessionStorage.setItem('inspectionRecorddataobj',JSON.stringify(this.itemdataobj))
    this.getWorkPolling(this.itemid);
  },

  methods: {
    submitForm(formName,code) {

        this.$refs[formName].validate((valid)=>{
          if (valid) {
            this.commit();
          } else {
            return false;
          }
        });
      },
     orderOpen(value){
            if(value=="close"){
              this.orderCode=false;
            }
      },
  assessClick(item){
     this.rateState=true;
     this.rowItem=item;
     if(this.$refs.cOrder)this.$refs.cOrder.getOne()
  },
  //点击编辑按钮
  editData(item){
	  let obj = {}
	  obj.businessId = item.id;
	  this.$axios.post('/dform/supervise/getOne', obj).then((res) => {
	  	if (res.data.code == 1 && res.data.data != null) {//有督办单
	  		this.$message({
	  			type: 'error',
	  			message:"已添加督办单，当前状态不可编辑",
	  		})
	  	}else{//没有督办单
	  		this.show = !this.show
	  		this.ruleForm = item
	  	}
	  })
  },
   change(value){
        let _that=this;
        _that.rateValue=value;
            if(value!==0){
              _that.rateState=false;
              _that.rateObj.assessmentScore=JSON.stringify(value);
              _that.$axios.post('/dform/workPolling/saveWorkPolling', _that.rateObj)
              .then((res) => {
              if(res.data.code){
               _that.$emit('getWorkPolling','')
               _that.$message({
							 type: 'success',
							 message:"打分成功",
               })
               _that.rateValue=0;
               _that.getWorkPolling(this.itemid);
               }
              })
            }
      },
    showAllClick(){
       this.showAll=true;
       this.tableHead.map(function(item){
         item.clearable=true;
       })
    },
    showSomeClick(){
      this.showAll=false;
       this.tableHead.map(function(item,index){
         if(index=='0' ||index=='1' ||index=='2'){
            item.clearable=true;
         }else{
            item.clearable=false;
         }
       })
    },
  changeValue(params){
      this.ruleForm.checkTime=params.value;
    },
  selectOper(val){
    this.multipleSelection = val
  },
  writeClick(){
    this.show1 = true;
  },
  uploadFiles(params){
      },
  getWorkPolling(id) {
        this.getTable.workid =id
        this.$axios.post('/dform/workPolling/listAll',this.getTable)
        .then((res) => {
          if(res.data.code){
            let arr1=res.data.data.rows
            let arr2=JSON.parse(JSON.stringify(arr1))
            this.tableData = arr2
          }
        })
    },
	recall(id){
		let obj = {}
		obj.businessId = id;
		this.$axios.post('/dform/supervise/getOne', obj).then((res) => {
			if (res.data.code == 1 && res.data.data != null) {//有督办单
				if(res.data.data.superviseUser == sessionStorage.getItem("userId")){
					let ids = [];
					ids.push(res.data.data.id);
					this.$axios.post('/dform/supervise/delWorkPolling', ids).then((res) => {
						if (res.data.data) {
							this.$message({
								type: 'success',
								message: "撤销成功",
							})
						}
					})
				}else{
					this.$message({
						type: 'error',
						message:"您没有撤销权限",
					})
				}
			}else{//没有督办单
				this.$message({
					type: 'error',
					message:"未添加督办单",
				})
			}
		})
	},
    delDetail(id) {
      let _that = this
      this.$confirm("是否确定删除该数据", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(async () => {
          let ids = []
          ids.push(id)
          this.$axios.post('/dform/workPolling/delWorkPolling', ids)
          .then((res) => {
            if(res.data.data){
              _that.$message({
                type: 'success',
                message:"删除成功",
              })
            }
            this.getWorkPolling(this.itemid);
          })
        })

    },
    onLoad() {},
    clickAddIcon() {
      this.show = !this.show;
      // this.ruleForm = JSON.parse(JSON.stringify(this.inspection))
      this.ruleForm = JSON.parse(JSON.stringify(this.ruleFormDemo))
      this.$set(this.ruleForm, 'id', this.common.uuid())
       let userInfo=sessionStorage.getItem("userInfo")
       userInfo=JSON.parse(userInfo)
       this.ruleForm.checkDept=userInfo.qyname
        let userCode=sessionStorage.getItem('loginFlag');
       if(userCode=='3'){//工厂用户
            this.ruleForm.qyName=userInfo.qyname
            this.ruleForm.qyId=userInfo.qyguid
            this.ruleForm.companyName=userInfo.suborganizationName
            this.ruleForm.companyId=userInfo.suborganization
             this.ruleForm.checkDept=userInfo.qyname
         }
          if(userCode=='6'){//相关方用户
            let relatedUnitObj=sessionStorage.getItem('relatedUnitObj')
              relatedUnitObj=JSON.parse(relatedUnitObj)
               this.ruleForm.checkDept=relatedUnitObj.orgName
            this.ruleForm.qyName=this.itemdataobj.GCMZ//sessionStorage.getItem('GCMZ')
            this.getQyId(this.ruleForm.qyName)
            this.ruleForm.companyName=this.itemdataobj.ZYHGSMZ//sessionStorage.getItem('ZYHGSMZ')
            this.getcompanyId(this.ruleForm.companyName)
         }
         if(userCode=='5'){//公司用户
            this.ruleForm.companyName=userInfo.qyname
            this.ruleForm.companyId=userInfo.qyguid
            this.ruleForm.qyName=this.itemdataobj.GCMZ//sessionStorage.getItem('GCMZ')
            this.getQyId(this.ruleForm.qyName)
            this.ruleForm.checkDept=userInfo.qyname
         }
         if(userCode=='2'){//集团用户
            this.ruleForm.companyName=this.itemdataobj.ZYHGSMZ//sessionStorage.getItem('ZYHGSMZ')
            this.getcompanyId(this.ruleForm.companyName)
            this.ruleForm.qyName=this.itemdataobj.GCMZ//sessionStorage.getItem('GCMZ')
            this.getQyId(this.ruleForm.qyName)
             this.ruleForm.checkDept=userInfo.qyname
         }
       //this.ruleForm.checkPeople=JSON.parse(sessionStorage.getItem('userInfo')).realName
       let loginUser=sessionStorage.getItem('loginUser')
       loginUser=JSON.parse(loginUser)
       this.ruleForm.checkPeople=loginUser.userName;
       this.ruleForm.checkPhone=loginUser.phoneNum;
       this.ruleForm.workClassify=this.itemdataobj.DHZY_ZYLB
       this.ruleForm.workLevel=this.itemdataobj.DHZY_ZYJB
       this.ruleForm.workCode=this.itemdataobj.DHZY_ZYZBH
       this.ruleForm.isRelation=this.itemdataobj.DHZY_XGFZY
       this.ruleForm.checkTime = new Date().Format("yyyy-MM-dd hh:mm")
    },
     getcompanyId(value){
         let obj={}
        obj.qyName=value;
        this.$axios.post('/user/qy/getQyTreeByQyName', obj).then((res) => {
          if(res.data.code == 1) {
              this.ruleForm.companyId=res.data.data[0].qyId;
            }
          })
      },
      getQyId(value){
        let obj={}
        obj.qyName=value;
        this.$axios.post('/user/qy/getQyTreeByQyName', obj).then((res) => {
          if(res.data.code == 1) {
              this.ruleForm.qyId=res.data.data[0].qyId;
            }
          })
      },
    clearwrite(id) {
      let _that = this;
      axios({
        method: "post", //请求类型
        url: "/mongodb/deleteMongodFileById?fileId=" + id, //,//请求地址,端口号
        //headers:{"Content-Type":"multipart/form-data;"}//自定义请求头
      })
        .then((res) => {
          if (res.data.code) {
            _that.$message({
              type: "success",
              message: "签字删除成功",
            });
            // _that.tableData[_that.itemParams.index][_that.itemParams.modelName] = ''
            _that.signId = "";
            //清除表格对应签字
          }
        })
        .catch((err) => {
          _that.$message({
            type: "error",
            message: err,
          });
        });
    },
    async commit(){
        let _that = this
        let fileArr = this.$refs.cUpload.$refs.cUpload.uploadFiles
        // if(_that.ruleForm.checkFlag!='合规' && fileArr.length == 0){
        //   this.$toast("请上传图片");
        //   return false;
        // }else
          if(fileArr.length != 0){
          await this.$refs.cUpload.$refs.cUpload.submit()
          this.ruleForm.imgbaseurl = sessionStorage.getItem("baseURL");
        }
        this.ruleForm.checkDeptType = sessionStorage.getItem("levelQy")
        this.ruleForm.workid = this.itemid
        this.$axios.post('/dform/workPolling/saveWorkPolling', this.ruleForm)
        .then((res) => {
          if(res.data.code){
            _that.inspectionState = false
            _that.show=false;
            this.getWorkPolling(this.itemid);
            _that.$message({
							type: 'success',
							message:"添加成功",
            })
          }
        })
      },
   async addSignBase64(base64){
		let _that = this
		_that.ruleForm.checkPeopleSignature = base64;
		_that.show1 = false;
/* 				let url = ''
				//////
				await axios({
					method:'post',//请求类型
					url: '/mongodb/uploadFile',//,//请求地址,端口号
					data: formdata, //request body
				}).then((res) => {
					if(res.data.code === 1){
			_that.ruleForm.checkPeopleSignature =res.data.data
						_that.$message({
							type: 'success',
							message:"文件上传成功",
			})
			_that.show1 = false;
					}
				}).catch((err) => {
					_that.$message({
						type: 'error',
						message:err,
					})
		})
 */      },
  },

  computed: {},

  watch: {},
};
</script>

<style scoped>
.inspectionRecord1{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  background: #fff;
}
.templateTable .formbox >>> .el-form-item.is-required .van-col--6:before,
.templateTable .formbox >>> .van-col--7.labelSpe:before{
  content: "*";
    color: #f56c6c;
}
.itemDetail >>> .upload-demo span:last-child{
	margin-left: 0;
}
.itemDetail div,
.van-swipe-cell__wrapper .imgBox div,
.imgBox >>> .el-row,
.imgBox >>> .el-col{
  margin-bottom: 0!important;
}
.itemDetail >>> .upload-demo .el-upload--picture-card{
  display: none;
}
.assessbtn{
  width: 100%;
  text-align: center;
  /* display: flex;
  justify-content: flex-end; */
}
.assessbtn .van-button{
  border-radius: 4px;
  margin: 0 .1rem;
}
.templateTable {
  width: 100%;
  height: 100%;
  background: #eee;
}
#wrap {
  position: fixed;
  right: 28px;
  bottom: 60px;
  width: 1.1rem;
  height: 1.1rem;
}
#home {
  position: absolute;
  width: 1.1rem;
  height: 1.1rem;
  background-repeat: no-repeat;
  z-index: 5;
  border-radius: 50%;
  transition: 0.5s;
}
.writeimg2{
  width: 73px;
  height: 73px;
  border: 1px solid black;
}
.writeimg2 img{
  width: 100px;
  height: 20px;
}
.addIcon {
  width: 1.1rem;
  height: 1.1rem;
  transition: transform 0.75s;
}
.cCommonTable {
  height: 90%;
  overflow-y: scroll;
}
.tableItem {
  background: #fff;
  margin: 0.2rem 0.3rem;
  border-radius: 5px;
  padding: 15px;
}
.itemDetailBox {
  width: 100%;
  display: inline-block;
}
/* 指定元素具体样式 */
.itemDetail {
  margin: 0 0 0.2rem;
  font-size: 0.38rem;
}
.itemDetail img {
  width: 200px;
  height: auto;
}
.itemTitle {
  color: #969799;
}
.itemValue {
  display: inline;
  margin-left: 10px;
}
.vanPopupF {
  width: 85%;
}

.templateForm {
  width: 100%;
  height: 100%;
  /* display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center; */
  background-color: #e1eef6;
   overflow-y: scroll;
   position: relative;
   top: -1.25rem;
}
.writediv {
  display: flex;
  justify-content: start;
  align-items: center;
}
.writediv button {
  width: 100px;
  height: 30px;
  border-radius: 30px;
  /* display:inline-block; */
  text-align: left;
  margin-left: 50px;
}
.formbox{
  width: 100%;
  height: 100%;
  background-color: #fff;
  overflow-y: scroll;
  position: relative;
  margin-bottom: 20px;
  margin-top: 1.25rem;
}
.topBar {
  height: 1.2rem;
  /* background: linear-gradient(90deg, #3eb2e7, #05469c); */
  color: #fff;
  font-size: 0.5rem;
  line-height: 1.2rem;
  position: fixed;
  bottom:0;
  width: 100%;
  left:0;
  margin-top: 20px;
}
.topBar p {
  display: inline;
}
.topBarImg {
  height: 0.5rem;
  line-height: 1.2rem;
  font-weight: bold;
}
.bottomBar {
  height: 1rem;
}
.bottomBar .el-button {
  width: 100%;
  background-color: #384c9b;
  color: #fff;
  font-size: 0.25rem;
}
.cancel {
  background-color: #2f2;
}
.delete {
  background-color: #f22;
}
.van-popup{
  padding: 30px 20px;
}
.canvascell{
  height: 100%;
}

.el-dialog__wrapper>>>.inspectionRecordBody1{
	height: auto;
	/* margin: 0 !important; */
}

</style>
